import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import PlaneConfig from "@/config/PlaneConfig";
import Facade from "@/Facade";
import gsap from 'gsap';
import SpineAnimation from "@base/spineAnimation/SpineAnimation";

export default class PlatformContainer extends BaseContainer {
  static MAX_JUMPING_ELVES = 7

  constructor(position) {
    super()

    this.init(position)
  }

  init(position) {
    this.arr = PlaneConfig.land

    Signals.makeBets.add(this.reset, this)
    Signals.roundStart.add(this.start, this)
    Signals.roundEnd.add(this.stop, this)

    this.container = new PIXI.Container()
    this.container.name = `Start point ${position}`

    this.startPoint = new SpineAnimation(`startingPoint${position}`)
    this.container.addChild(this.startPoint)

    // There is 'elf_start' animation
    if (position === 'Bot') {
      this.jumpingElf = new SpineAnimation('jumpingElf')
      this.jumpingElf.position.set(74, 240)
      this.container.addChild(this.jumpingElf)
    }

    this.addChild(this.container)

    this.reset()
  }

  reset() {
    this.stop()
    this.container.position.set(0, 0)
    const repeat = new Array(PlatformContainer.MAX_JUMPING_ELVES).fill('elf_start');
    this.jumpingElf?.start(repeat, repeat.map(v => !v))
  }

  start() {
    this.jumpingElf && this.jumpingElf.stop()
    this.jumpingElf && gsap.to(this.jumpingElf, 0.1, {
      alpha: 0, onComplete: () => {
        this.jumpingElf.alpha = 1
      }
    })

    this.a = Math.round(Facade.model.deltaTime * 60)
    if (Facade.model.deltaTime < 0 || this.a >= this.arr.length - 1) {
      this.a = this.arr.length - 1
      const o = this.arr[this.arr.length - 1]

      this.container.x = o.x
      this.container.visible = true

      return
    }

    Signals.tick.add(this.update, this)

    // this.arr.length = 0
    // TweenMax.to(this.container, 2, {
    //   x: -828, ease: 'none', onComplete: () => {
    //     this.stop()
    //     console.log('::: platform path tracking', this.arr)
    //   }
    // })
  }

  stop() {
    Signals.tick.remove(this.update, this)
  }

  update() {
    // const a = {
    //   x: Number(this.container.x.toFixed(2))
    // }
    // this.arr.push(a)

    const o = this.arr[this.a]
    if (!o) console.log("ERROR", this.a, o)
    this.container.x = o.x
    this.a++
    if (this.a === this.arr.length) {
      this.a = this.arr.length - 1
      this.stop()
    }
  }

}
